import axios from 'axios';
import { getApiUrl } from '../config/api';
import { cacheClearAll } from './cacheManager';

let memoVersion: { version: number; updatedAt: string } | null = null;
let inflight: Promise<{ version: number; updatedAt: string } | null> | null = null;

export async function fetchContentVersion(): Promise<{ version: number; updatedAt: string } | null> {
  try {
    const res = await axios.get(getApiUrl('cache/version'));
    return res.data as { version: number; updatedAt: string };
  } catch (e) {
    // If Express API is unavailable, gracefully return null; client will fallback to cache without versioning
    return null;
  }
}

export async function getContentVersionCached(): Promise<{ version: number; updatedAt: string } | null> {
  if (memoVersion) return memoVersion;
  if (!inflight) {
    inflight = (async () => {
      const v = await fetchContentVersion();
      try {
        if (v) {
          const prevRaw = sessionStorage.getItem('contentVersion');
          const prev = prevRaw ? Number(prevRaw) : null;
          if (prev !== v.version) {
            // Version changed since last session fetch; clear cache for a clean slate
            await cacheClearAll();
            sessionStorage.setItem('contentVersion', String(v.version));
          }
        }
      } catch {}
      return v;
    })().finally(() => { inflight = null; });
  }
  memoVersion = await inflight;
  return memoVersion;
}

export function setContentVersionForSession(v: { version: number; updatedAt: string } | null) {
  memoVersion = v;
}
